import React from 'react';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import BrandedButton from '../../../Buttons/BrandedButton';
import s from './ThumbMiddleContent.scss';
const ThumbMiddleContent = ({ icon , title , subtitle , buttonTitle , onButtonClick , biData , className , buttonHref  })=>/*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK,
        tag: "div",
        className: classnames(s['root'], className)
    }, icon && /*#__PURE__*/ React.createElement("div", {
        className: s['icon']
    }, icon), title && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), subtitle && /*#__PURE__*/ React.createElement("div", {
        className: s['subtitle']
    }, subtitle), buttonTitle && /*#__PURE__*/ React.createElement(BrandedButton, {
        variant: "brand-green",
        size: "medium",
        onClick: onButtonClick,
        href: buttonHref,
        biData: biData,
        className: s['button']
    }, buttonTitle));
ThumbMiddleContent.displayName = 'ThumbMiddleContent';
export default ThumbMiddleContent;
